import HomeContent from './HomeContent';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';

export default function Home() {
  return (
    <>
      <SEOHead
        title="17吃瓜网官网 | 17吃瓜爆料 - 网红黑料每日更新 | 在线吃瓜视频"
        description="17吃瓜网🌟官网汇集全网热门吃瓜爆料、🔍网红黑料、明星塌房事件，提供17吃瓜在线视频实时追踪，每日更新最新黑料大瓜，让你第一时间掌握网络热门猛料。17吃瓜爆料、黑料视频、每日吃瓜尽在17吃瓜网。"
        keywords="17吃瓜网,17吃瓜爆料,17吃瓜黑料,17吃瓜在线,17黑料吃瓜,17吃瓜黑料网,17吃瓜官网,网红黑料,每日吃瓜,黑料视频,吃瓜爆料,17吃瓜视频"
        canonicalUrl="http://1wujie.cn/"
      />
      <Navbar />
      <main>
        <HomeContent />
      </main>
      <Footer />
    </>
  );
}